module.exports = __webpack_public_path__ + "static/media/bark-min.043e2676.png";